import React, { Component } from 'react';
import {ISDEMO} from '../cache';
import auth from '../utils/auth'
/* 是否是新用户，是否创建过农场。
* 当未创建农场，则不允许操作。
* */
export default class FarmLess extends Component {
  constructor (props) {
    super(props);
  }
  onCancel = () => {
    this.props.onCancel && this.props.onCancel();
    document.querySelector('#root').style.pointerEvents = 'auto';
  };
  render() {
    let {show} = this.props;
    const coop = auth.getCookie('coop')=== 'true';
    const DEMO = (auth.getCookie('farm_flag') === 'false');
    let str1 = '';
    let str2 = '';
    let btn1 = '';
    if (DEMO) {
      str1 = '您还没有创建属于您的猪场哦';
      str2 = '创建成功后您就可以开始使用养殖管理啦';
      btn1 =  '创建猪场'
    } else if (!DEMO && !coop) {
      str1 = '您还没有达成合作哦';
      str2 = '目前只能预览，达成合作后就可以使用它啦！';
      btn1 =  '我要合作'
    }
    // alert('farmless  合作' + auth.getCookie('coop') + '   farm_flag=' + auth.getCookie('farm_flag') + ' farmorg' + auth.getCookie('farmorg') + ' orgcode' + auth.getCookie('orgcode'));
  return (
    <React.Fragment>
      <div className="warning-wrap"
          style={{display: show ? 'block': 'none'}}
      >
        <div className="child"
            onClick={() => {

        }}
        >
          <div className="child-content">
            <section style={{padding: '25px 0 15px',textAlign: 'center',fontSize: '0.4rem',fontWeight: 500}}>{str1}</section>
            <section style={{textAlign: 'center',fontSize: '0.3rem',fontWeight: 100}}>{str2}</section>
          </div>
          <div className="child-footer">
            <div className="left"
                onClick={this.onCancel}
            >
              我再看看
            </div>
            <div className="right"
                onClick={() => {
                  if (DEMO) {
                    this.props.history.replace('/setting')
                  } else {
                    this.props.history.replace('/cooperate')
                  }
                }}
            >
              {btn1}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
 }
}
